import { Link } from 'react-router-dom';
import Restricted from 'src/app/permissions/restricted';
import { useAppSelector } from 'src/services/redux/app/store';
import { MenuItem } from './MenuItem';

export function MenuInner() {
  const { user } = useAppSelector((state) => state.auth);
  const company = user?.company;
  const { payment_details } = useAppSelector((state) => state.paymentsDetail);

  // Profil tamamlanma yüzdesini hesapla
  const calculateProfileCompletion = () => {
    let completedFields = 0;
    let totalFields = 14;

    // Profil Bilgileri (7 alan)
    if (company?.company_logo) completedFields++;
    if (company?.contact_name) completedFields++;
    if (company?.contact_surname) completedFields++;
    if (company?.company_name) completedFields++;
    if (company?.contact_phone) completedFields++;
    if (company?.web_site) completedFields++;
    if (company?.tax_number) completedFields++;

    // Ödeme Ayarları (7 alan)
    if (payment_details?.taxOffice) completedFields++;
    if (payment_details?.legalCompanyTitle) completedFields++;
    if (payment_details?.email) completedFields++;
    if (payment_details?.address) completedFields++;
    if (payment_details?.iban) completedFields++;
    if (payment_details?.gsmNumber) completedFields++;
    if (payment_details?.name) completedFields++;

    return Math.round((completedFields / totalFields) * 100);
  };

  const profileCompletion = calculateProfileCompletion();

  return (
    <>
      <Restricted to="ROLE_DASHBOARD">
        <MenuItem title={'Gösterge Paneli'} to="/dashboard" />
      </Restricted>
      <div className="position-relative d-lg-flex justify-content-center align-items-center">
        <div className="notes-joyride">
          <MenuItem title="Notlarım" to="/todos" />
        </div>
      </div>

      {/* Profil Tamamlanma Uyarısı */}
      {profileCompletion < 100 && (
        <div className="menu-item px-3 py-2 ml-5">
          <div className="alert alert-warning d-flex align-items-center p-3 mb-0" role="alert">
            <i className="bi bi-exclamation-triangle-fill fs-3 me-3"></i>
            <div className="d-flex flex-column flex-grow-1 me-2">
              <span className="fw-bold fs-7">Profil Bilgileri Tamamlama: %{profileCompletion}</span>
              <span className="text-muted fs-8">Bilgilerinizi tamamlayın</span>
            </div>
            <Link to="/account/profile" className="btn btn-sm btn-warning fw-bold">
              Tamamla
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
